import { stripHtmlTags } from '../lib/functions';

export const Breadcrumb = {
  namespaced: true,
  state: {
    path: [],
  },
  getters: {
    path: (state: any) => {
      return state.path;
    },
  },
  mutations: {
    setPath: (state: any, path: BreadcrumbPath[]) => {
      path.forEach((item) => {
        item.label = stripHtmlTags(item.label);
      });
      state.path = path;
    },
  },
};
